import "core-js/modules/es.array.push.js";
// 定数
const classroomListLimit = 2;
const __default__ = {
  name: "TeachersIndex",
  head: {
    title: () => ({
      inner: "教員一覧"
    }),
    meta: []
  },
  computed: { ...mapState(["grades"])
  }
};
import { ref, reactive, computed } from "vue";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const isLoading = reactive({
      teachers: true
    });
    const teachers = ref([]); // API からとってきたオリジナルデータ

    const filterTeachers = ref([]); // filterしたデータ

    const setData = async () => {
      const data = await getData("reader/get_teachers_with_classrooms");
      teachers.value = filterTeachers.value = reformatTeachers(data.items);
      isLoading.teachers = false;
    };

    const reformatTeachers = originalList => {
      const newList = [];
      originalList.forEach(v => {
        // 現在の教師がすでに newList にいるかチェック（いる場合は複数クラスを担任していることになる）
        // みつからなければ新規作成。
        // 見つかった場合はそこに push
        const duplicatedTeacher = newList.find(({
          id
        }) => id === v.id);
        const classroomObj = createTeacherClassroomObj(v);

        if (duplicatedTeacher) {
          if (classroomObj) {
            duplicatedTeacher.classrooms.push(classroomObj);
          }
        } else {
          newList.push({
            id: v.id,
            user_id: v.user_id,
            role_id: v.role_id,
            name: v.name,
            teacher_number: v.teacher_number,
            email: v.email,
            grade_index: v.fiscal_year ? null : v.grade_index,
            classroom_index: v.classroom_index,
            classrooms: classroomObj ? [classroomObj] : [],
            fiscal_year: v.fiscal_year,
            school_id: v.school_id
          });
        }
      });
      return newList;
    };

    const createTeacherClassroomObj = v => {
      return !v.fiscal_year && v.classroom_id ? {
        classroom_id: v.classroom_id,
        classroom_name: v.classroom_name,
        grade_id: v.grade_id,
        grade_name: v.grade_name
      } : null;
    };

    const filterKeyword = ref("");
    const filterGrade = ref("");

    const handleFilterData = e => {
      e.preventDefault();
      filterTeachers.value = filterData();
    };

    const filterData = () => {
      if (filterGrade.value && filterKeyword.value) {
        return teachers.value.filter(v => v.classrooms && v.classrooms.find(v2 => v2.grade_id === filterGrade.value) && Object.keys(v).some(k => String(v[k]).indexOf(filterKeyword.value) > -1));
      } else if (filterGrade.value) {
        return teachers.value.filter(v => v.classrooms && v.classrooms.find(v2 => v2.grade_id === filterGrade.value));
      } else if (filterKeyword.value) {
        return teachers.value.filter(v => Object.keys(v).some(k => String(v[k]).indexOf(filterKeyword.value) > -1));
      }

      return teachers.value;
    };

    const sortStatus = reactive({
      key: "name",
      order: "desc"
    });

    const changeSort = (key, order) => {
      sortStatus.key = key;
      sortStatus.order = order;
    }; // filterTeachersかsortKeyに変更があったら副作用的に実行する


    const visibleTeachers = computed(() => {
      return sortData();
    });

    const sortData = () => {
      return filterTeachers.value.sort((a, b) => {
        let v = 0;

        if (sortStatus.key === "name") {
          // unicode順？に並べる
          if (a.name < b.name) {
            v = -1;
          } else if (a.name > b.name) {
            v = 1;
          }
        } else if (sortStatus.key === "role") {
          // 管理者->一般の順にしつつ,グループ内ではname順にする
          if (a.role_id < b.role_id) {
            v = -1;
          } else if (a.role_id > b.role_id) {
            v = 1;
          } else {
            if (a.name < b.name) {
              v = -1;
            } else if (a.name > b.name) {
              v = 1;
            }
          }
        } else if (sortStatus.key === "classroom") {
          // 基本はapiから取得したクラス順に準拠しつつ、グループ内ではname順にする
          if (a.grade_index < b.grade_index) {
            v = -1;
          } else if (a.grade_index > b.grade_index) {
            v = 1;
          } else {
            if (a.classroom_index < b.classroom_index) {
              v = -1;
            } else if (a.classroom_index > b.classroom_index) {
              v = 1;
            } else {
              if (a.name < b.name) {
                v = -1;
              } else if (a.name > b.name) {
                v = 1;
              }
            }
          }
        }

        return sortStatus.order === "desc" ? v : -1 * v;
      });
    }; // created


    setData();
    return {
      __sfc: true,
      classroomListLimit,
      isLoading,
      teachers,
      filterTeachers,
      setData,
      reformatTeachers,
      createTeacherClassroomObj,
      filterKeyword,
      filterGrade,
      handleFilterData,
      filterData,
      sortStatus,
      changeSort,
      visibleTeachers,
      sortData,
      RowItem
    };
  }

});